"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uploadBase = _interopRequireDefault(require("./upload-base"));

var _directBinaryUploadProcess = _interopRequireDefault(require("./direct-binary-upload-process"));

var _uploadResult = _interopRequireDefault(require("./upload-result"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Provides capabilities for uploading assets to an AEM instance configured with
 * direct binary access.
 */
var DirectBinaryUpload = /*#__PURE__*/function (_UploadBase) {
  _inherits(DirectBinaryUpload, _UploadBase);

  var _super = _createSuper(DirectBinaryUpload);

  function DirectBinaryUpload() {
    _classCallCheck(this, DirectBinaryUpload);

    return _super.apply(this, arguments);
  }

  _createClass(DirectBinaryUpload, [{
    key: "uploadFiles",

    /**
     * Uploads multiple files to a target AEM instance. Through configuration,
     * supports various potential sources, including a node.js process or a
     * browser.
     *
     * @param {DirectBinaryUploadOptions} options Controls how the upload will behave. See class
     *  documentation for more details.
     * @returns {Promise} Will be resolved when all the files have been uploaded. The data
     *  passed in successful resolution will be an instance of UploadResult.
     */
    value: function () {
      var _uploadFiles = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        var _this = this;

        var uploadProcess, uploadResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uploadProcess = new _directBinaryUploadProcess.default(this.getOptions(), options);
                uploadResult = new _uploadResult.default(this.getOptions(), options);
                uploadProcess.on('filestart', function (data) {
                  return _this.sendEvent('filestart', data);
                });
                uploadProcess.on('fileprogress', function (data) {
                  return _this.sendEvent('fileprogress', data);
                });
                uploadProcess.on('fileend', function (data) {
                  return _this.sendEvent('fileend', data);
                });
                uploadProcess.on('fileerror', function (data) {
                  return _this.sendEvent('fileerror', data);
                });
                uploadProcess.on('filecancelled', function (data) {
                  return _this.sendEvent('filecancelled', data);
                });
                _context.next = 9;
                return uploadProcess.upload(uploadResult);

              case 9:
                return _context.abrupt("return", uploadResult);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadFiles(_x) {
        return _uploadFiles.apply(this, arguments);
      }

      return uploadFiles;
    }()
    /**
     * Determines whether a given upload can be performed. If the upload is not possible then
     * the method will throw an UploadError whose code specifies the reason why the upload
     * cannot happen.
     * @param {DirectBinaryUploadOptions} options Options for the proposed upload. See module
     *  documentation for details.
     */

  }, {
    key: "canUpload",
    value: function () {
      var _canUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(options) {
        var uploadProcess;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                uploadProcess = new _directBinaryUploadProcess.default(this.getOptions(), options);
                _context2.next = 3;
                return uploadProcess.initiateUpload(new _uploadResult.default(this.getOptions(), options), [{
                  fileName: "".concat(new Date().getTime(), "_canUploadTest.jpg"),
                  fileSize: 1,
                  blob: [1]
                }]);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function canUpload(_x2) {
        return _canUpload.apply(this, arguments);
      }

      return canUpload;
    }()
  }]);

  return DirectBinaryUpload;
}(_uploadBase.default);

exports.default = DirectBinaryUpload;